<div class="container">
  <div class="content-text position-relative">
    <div class="animate-element wow delay5 fadeInDown" data-wow-delay="0.3s">
      <div class="tag color-d1 lt-sp53 mg-b34">Frontend Developer</div>

      <h1 class="cd-headline clip is-full-width title color-d11 mg-b41">
        <span class="pr-2">Hello, I'm  </span>
        <span class="cd-words-wrapper color-d6">
          <b class="is-visible"> Naomi!</b>
          <b> Nae!</b>
        </span>
      </h1>

    </div>

  </div>
  <div class="featured-post border-corner-bl">
    <img src="../../../assets/images/section/nao1.JPG" alt="images">

  </div>
</div>
